import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Select } from "antd";
import LazyLoadSelect from "../../components/LazyLoadSelect";
const ProductSelect = ({ tenantId, disabled = false, value, product, style, allowClear, filterActive = true, filterHasActiveOrInactiveLocation, filterHasActiveLocation, onChange, onProductSelected, markInactive = false, prefixOptionWithReference, }) => {
    const optionsRenderer = (products) => {
        function renderOptionChild(product) {
            let text = product.description || '';
            if (prefixOptionWithReference && product.reference) {
                text = product.reference + ' ' + text;
            }
            if (markInactive) {
                if (product.active) {
                    return (_jsx("span", { children: text }));
                }
                else {
                    return (_jsx("span", { style: {
                            textDecorationLine: 'line-through',
                            textDecorationColor: '#888',
                            textDecorationThickness: '7%'
                        }, children: text }));
                }
            }
            return text;
        }
        return products.map((product) => {
            let filter = '';
            if (product.reference) {
                filter = product.reference;
            }
            if (product.description) {
                filter += ' ' + product.description;
            }
            return _jsx(Select.Option, { value: product.id, filter: filter, children: renderOptionChild(product) }, product.id);
        });
    };
    return (_jsx(LazyLoadSelect, { url: "/admin/v1/products", tenantId: tenantId, disabled: disabled, allowClear: allowClear, style: style, value: value || product?.id, placeholder: "Select a product", notFoundMessage: "No products found", searchKey: "referenceOrDescriptionLike", queryParams: {
            hasActiveOrInactiveLocation: filterHasActiveOrInactiveLocation ? true : undefined,
            hasActiveLocation: filterHasActiveLocation,
            active: filterActive
        }, onChange: onChange, onSelected: onProductSelected, optionsRenderer: optionsRenderer }));
};
export default ProductSelect;
